import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { AuthForm } from './AuthForm';

export const LoginForm = ({ afterSubmit }: { afterSubmit: () => void }) => {
  const { signIn, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await signIn(email, password);
    afterSubmit();
  };

  return (
    <AuthForm
      title="Log In"
      onSubmit={handleSubmit}
      submitLabel="Log In"
      error={error}
    >
      <TextField
        label="Email"
        type="email"
        value={email}
        name="email"
        onChange={(e) => setEmail(e.target.value)}
        required
        fullWidth
        autoComplete="email"
      />
      <TextField
        label="Password"
        type="password"
        name="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        fullWidth
        autoComplete="current-password"
      />
    </AuthForm>
  );
};
